module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-diff-8922a3ce.svg";